////import Signup from "./components/Signup";
//import "font-awesome/css/font-awesome.min.css";
//import React, { useEffect } from "react";
//import ReactNotification from "react-notifications-component";
//import "react-notifications-component/dist/theme.css";
//import { connect } from "react-redux";
//import { BrowserRouter, Route, Switch } from "react-router-dom";
//import { loadUser } from "./actions/authActions";
//import { loadBioData } from "./actions/loadBioData";
//import socket from "./actions/socketIO";
//import Dashboard from "./components/Dashboard";
//import DocDetailPage from "./components/DocDetailPage";
//import DocumentScreen from "./components/DocumentScreen";
//import Login from "./components/Login";
//import NotificationScreen from "./components/NotificationScreen";
//import Pageloading from "./components/pageloading";
//import Shop from "./components/ShopManagmentScreen";
//import StaffTravelScreen from "./components/StaffTravelScreen";
//import UserRegistration from "./components/UserRegistration/UserRegistration";
//import { IP } from "./config/IP";
//import store from "./store/createStore";
//
//const token = localStorage.getItem("token");
//
//function App(props) {
//	useEffect(() => {
//		if (props.state.auth.isAuthenticated) {
//			try {
//				let inputs = {
//					url: IP.nodeServer + "api/getEmployeeBioData",
//					method: "POST",
//					data: [
//						{
//							name: "username",
//							value: props.state.auth.user.allUser.find(
//								(y) => y._id === props.state.auth.user.usernameId
//							).username,
//						},
//					],
//				};
//
//				store.dispatch(loadBioData(inputs));
//			} catch (e) { }
//		}
//	}, [props.state.auth.isAuthenticated]);
//	useEffect(() => {
//		let selectedCompanyId = localStorage.getItem("selectedCompanyId");
//		store.dispatch(
//			loadUser({
//				companyData: props.state.companyData.isSaved
//					? props.state.companyData
//					: {
//						isSaved: selectedCompanyId ? true : false,
//						selectedCompanyId: selectedCompanyId ? selectedCompanyId : "",
//					},
//			})
//		);
//
//		try {
//			socket.on("newConnection", (data) => {
//				console.log("from socket io on newConnection=", data);
//			});
//		} catch (e) {
//			console.err("Express server connection error=", e);
//		}
//	}, []);
//
//	//console.log("store=", store);
//	console.log("App props.state.auth=", props.state.auth);
//	//console.log("this.state=", state);
//
//
//	return (
//		<div>
//			<ReactNotification />
//			{props.state.auth.isAuthenticated
//				? (
//					<BrowserRouter>
//						<Switch>
//							<Route exact path="/">
//								<Dashboard />
//							</Route>
//
//							<Route path="/notification">
//								<NotificationScreen />
//							</Route>
//							<Route path="/document">
//								{props.state.userStatus.status ? (
//									<DocumentScreen />
//								) : (
//									<Pageloading />
//								)}
//							</Route>
//							<Route path="/DocDetail/:DocId">
//								<DocDetailPage />
//							</Route>
//							<Route path="/StaffTravel">
//								<StaffTravelScreen />
//							</Route>
//							<Route path="/Shop">
//								<Shop />
//							</Route>
//						</Switch>
//					</BrowserRouter>
//				) : props.state.auth.isLoading /*&& props.state.auth.isAuthenticated*/ ===
//					true ? (
//					<Pageloading />
//				) : (
//					<BrowserRouter>
//						<Switch>
//							<Route exact path="/Register">
//								<UserRegistration />
//							</Route>
//							<Route>
//
//								<Login />
//							</Route>
//						</Switch>
//					</BrowserRouter>
//				)}
//		</div>
//	);
//}
///*const mapStateToProps = state => ({
//	currentUser: currentUser ? currentUser : {}
//});
//*/
//const mapStateToProps = (state) => ({ state });
//
//export default connect(mapStateToProps)(App);
//
////export default App;

//import Signup from "./components/Signup";
import "font-awesome/css/font-awesome.min.css";
import React, { useEffect } from "react";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { connect } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { loadUser } from "./actions/authActions";
import { loadBioData } from "./actions/loadBioData";
import socket from "./actions/socketIO";
import Dashboard from "./components/Dashboard";
import DocDetailPage from "./components/DocDetailPage";
import DocumentScreen from "./components/DocumentScreen";
import Login from "./components/Login";
import NotificationScreen from "./components/NotificationScreen";
import Pageloading from "./components/pageloading";
import Shop from "./components/ShopManagmentScreen";
import StaffTravelScreen from "./components/StaffTravelScreen";
import UserRegistration from "./components/UserRegistration/UserRegistration";
import { IP } from "./config/IP";
import store from "./store/createStore";
import FormerStaffLogin from "./components/LoginFormerStaff";
import LoginWithOTP from "./components/LoginWithOTP";

const token = localStorage.getItem("token");

function App(props) {
	useEffect(() => {
		if (props.state.auth.isAuthenticated) {
			try {
				let inputs = {
					url: IP.nodeServer + "api/getEmployeeBioData",
					method: "POST",
					data: [
						{
							name: "username",
							value: props.state.auth.user.allUser.find(
								(y) => y._id === props.state.auth.user.usernameId
							).username,
						},
					],
				};

				store.dispatch(loadBioData(inputs));
			} catch (e) { }
		}
	}, [props.state.auth.isAuthenticated]);
	useEffect(() => {
		let selectedCompanyId = localStorage.getItem("selectedCompanyId");
		if(token) {
			store.dispatch(
				loadUser({
					companyData: props.state.companyData.isSaved
						? props.state.companyData
						: {
							isSaved: selectedCompanyId ? true : false,
							selectedCompanyId: selectedCompanyId ? selectedCompanyId : "",
						},
				})
			);
		}

		try {
			socket.on("newConnection", (data) => {
				console.log("from socket io on newConnection=", data);
			});
		} catch (e) {
			console.err("Express server connection error=", e);
		}
	}, []);

	//console.log("store=", store);
	console.log("App props.state.auth=", props.state.auth);
	//console.log("this.state=", state);


	return (
		<div>
			<ReactNotification />
			{props.state.auth.isAuthenticated
				? (
					<BrowserRouter>
						<Switch>
							<Route exact path="/">
								<Dashboard />
							</Route>

							<Route path="/notification">
								<NotificationScreen />
							</Route>
							<Route path="/document">
								{props.state.userStatus.status ? (
									<DocumentScreen />
								) : (
									<Pageloading />
								)}
							</Route>
							<Route path="/DocDetail/:DocId">
								<DocDetailPage />
							</Route>
							<Route path="/StaffTravel">
								<StaffTravelScreen />
							</Route>
							<Route path="/Shop">
								<Shop />
							</Route>
              {/* e.g. /verify-otp or /formerstafflogin right after login */}
							<Redirect to="/" />
						</Switch>
					</BrowserRouter>
				) : props.state.auth.isLoading /*&& props.state.auth.isAuthenticated*/ ===
					true ? (
					<Pageloading />
				) : (
					<BrowserRouter>
						<Switch>
							<Route exact path="/formerstafflogin">
								<FormerStaffLogin />
							</Route>
							<Route exact path="/verify-otp">
								<LoginWithOTP />
							</Route>
							<Route exact path="/Register">
								<UserRegistration />
							</Route>
							<Route>
								<Login />
							</Route>
						</Switch>
					</BrowserRouter>
				)}
		</div>
	);
}
/*const mapStateToProps = state => ({
	currentUser: currentUser ? currentUser : {}
});
*/
const mapStateToProps = (state) => ({ state });

export default connect(mapStateToProps)(App);

//export default App;
